// extracted by mini-css-extract-plugin
module.exports = {"tooltip-placeholder":"tooltip-placeholder-niioe"};